import { defineStore } from 'pinia'
import Actions from './actions'
import { useState } from './state'

export { type CruiseState } from './state'

export const useCruiseStore = defineStore('cruise', {
  state: useState,
  actions: { ...Actions },
})

export type CruiseStoreContext = ReturnType<typeof useCruiseStore>